var React = require('react');

function ContractsGrey (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("g",{"stroke":"#4F4F4F","strokeWidth":".926","key":0},[React.createElement("rect",{"width":"16.491","height":"17.992","x":".463","y":".463","rx":"1","key":0}),React.createElement("path",{"strokeLinecap":"round","d":"M2.903 4.524h11.61M2.903 7.814h9.61M2.903 11.104h6.61M2.903 14.394h5.61","key":1})]),React.createElement("ellipse",{"cx":"15.476","cy":"13.686","fill":"#FFF","rx":"5.958","ry":"5.909","key":1}),React.createElement("ellipse",{"cx":"15.583","cy":"13.636","stroke":"#4F4F4F","strokeWidth":".926","rx":"4.583","ry":"4.545","key":2}),React.createElement("path",{"stroke":"#4F4F4F","strokeLinecap":"round","strokeWidth":".926","d":"M13.683 13.94l1.34 1.258 2.529-3.19","key":3})]));
}

ContractsGrey.defaultProps = {"viewBox":"0 0 22 20"};

module.exports = ContractsGrey;

ContractsGrey.default = ContractsGrey;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/contracts-grey.svg
// module id = 1468
// module chunks = 0